export const STUDIO_ADD_OR_UPDATE_DESIGN = 'LS_STUDIO/ADD_OR_UPDATE_DESIGN';
export const STUDIO_ADD_OR_UPDATE_DESIGN_SNAPSHOT = 'LS_STUDIO/ADD_OR_UPDATE_DESIGN_SNAPSHOT';
export const STUDIO_ADD_OR_UPDATE_PACKAGES = 'LS_STUDIO/STUDIO_ADD_OR_UPDATE_PACKAGES';
export const STUDIO_ADD_OR_UPDATE_PRODUCT = 'LS_STUDIO/ADD_OR_UPDATE_PRODUCT';
export const STUDIO_ADD_OR_UPDATE_REVISION = 'LS_STUDIO/ADD_OR_UPDATE_REVISION';
export const STUDIO_ADD_OR_UPDATE_RENDERS = 'LS_STUDIO/ADD_OR_UPDATE_RENDERS';
export const STUDIO_ADD_OR_UPDATE_SPACE = 'LS_STUDIO/ADD_OR_UPDATE_SPACE';
export const STUDIO_BATCH_ADD_OR_UPDATE_PRODUCTS = 'LS_STUDIO/BATCH_ADD_OR_UPDATE_PRODUCTS';
export const STUDIO_RECEIVE_PRODUCTS_PURCHASED = 'LS_STUDIO/RECEIVE_PRODUCTS_PURCHASED';
export const SUBMIT_REDESIGN_REQUEST = 'LS_STUDIO/SUBMIT_REDESIGN_REQUEST';
export const SELECT_HOTSPOT_PRODUCT = 'LS_STUDIO/SELECT_HOTSPOT_PRODUCT';
export const SELECT_PDP_HOTSPOT_PRODUCT = 'LS_STUDIO/SELECT_PDP_HOTSPOT_PRODUCT';
export const STUDIO_SET_ROUTER_PARAMS = 'LS_STUDIO/SET_ROUTER_PARAMS';
export const STUDIO_DELETE_DESIGN = 'LS_STUDIO/DELETE_DESIGN';
export const STUDIO_SET_DESIGN_SELECTOR_ACTIVE = 'LS_STUDIO/STUDIO_SET_DESIGN_SELECTOR_ACTIVE';
export const STUDIO_SET_SHOW_HIDE_LOOKBOOK = 'LS_STUDIO/STUDIO_SET_SHOW_HIDE_LOOKBOOK';
export const STUDIO_SET_PRODUCT_VIEW_ACTIVE = 'LS_STUDIO/STUDIO_SET_PRODUCT_VIEW_ACTIVE';
export const STUDIO_SET_LAYOUT_MODAL_ACTIVE = 'LS_STUDIO/STUDIO_SET_LAYOUT_MODAL_ACTIVE';
export const STUDIO_SET_LOCALLY_SELECTED_LAYOUT = 'LS_STUDIO/STUDIO_SET_LOCALLY_SELECTED_LAYOUT';

export const STUDIO_TOGGLE_BANNER_Z_INDEX = 'LS_STUDIO/STUDIO_TOGGLE_BANNER_Z_INDEX';
